(function ($) {
	'use strict';

	function citySearchUrl($element) {
		return $element.data('cities-url') || $('[data-cities-url]').first().data('cities-url') || '/ajax/cities';
	}

	function fetchCities(url, query, done) {
		return $.ajax({
			url: url,
			type: 'GET',
			dataType: 'json',
			data: {q: (query || '').trim()},
			headers: {'X-Requested-With': 'XMLHttpRequest'}
		}).done(function (response) {
			done(response.items || []);
		});
	}

	function cityQuery(value) {
		return String(value || '').trim();
	}

	function initCitySelect($select) {
		if ($select.data('cityAutocompleteReady')) return;
		$select.data('cityAutocompleteReady', true);

		const url = citySearchUrl($select);
		const placeholder = $select.find('option:first').text() || window.___('Оберіть місто');
		const selectedText = $select.find('option:selected').val() ? $select.find('option:selected').text() : '';
		const $wrap = $('<div class="resume-city-autocomplete resume-single-autocomplete"></div>');
		const $field = $('<div class="resume-tag-input resume-city-autocomplete__field"></div>');
		const $input = $('<input type="search" autocomplete="off">').attr('placeholder', placeholder).val(selectedText);
		const $list = $('<ul class="resume-autocomplete-list bg-white dark:bg-slate-900 dark:shadow-gray-800"></ul>');
		let activeRequest = null;
		let debounceTimer = null;
		let validValue = selectedText;
		let validId = $select.val() || '';

		$select.after($wrap.append($field.append($input), $list)).addClass('employer-native-select resume-native-select');

		function render(items) {
			$list.empty();
			items.forEach(function (city) {
				const displayName = city.display_name || city.name;
				$list.append($('<li></li>').text(displayName).attr('data-id', city.id).attr('data-value', city.name).attr('data-display-value', displayName));
			});
			$list.toggle(items.length > 0);
		}

		function load(query) {
			query = cityQuery(query);
			if (!query.length) {
				if (activeRequest) {
					activeRequest.abort();
					activeRequest = null;
				}
				$list.empty().hide();
				return;
			}
			if (activeRequest) activeRequest.abort();
			activeRequest = fetchCities(url, query, render).always(function () {
				activeRequest = null;
			});
		}

		function selectCity(id, name, displayName) {
			displayName = displayName || name;
			$('select[name="' + $select.attr('name') + '"]').each(function () {
				const $related = $(this);
				if (!$related.find('option[value="' + id + '"]').length) {
					$related.append($('<option></option>').attr('value', id).text(displayName));
				}
			});
			validId = String(id);
			validValue = displayName;
			$select.val(validId).trigger('change');
			$input.val(validValue);
			$list.hide();
		}

		$input.on('focus click', function (event) {
			event.stopPropagation();
			$list.hide();
		});

		$input.on('input', function () {
			if (!cityQuery($input.val()) && (validId || validValue)) {
				validId = '';
				validValue = '';
				$select.val('').trigger('change.cityAutocomplete').trigger('change').trigger('cityAutocomplete:clear');
				$list.empty().hide();
				return;
			}

			clearTimeout(debounceTimer);
			debounceTimer = setTimeout(function () {
				load($input.val());
			}, 250);
		});

		$list.on('mousedown', 'li', function (event) {
			event.preventDefault();
			selectCity($(this).data('id'), $(this).data('value'), $(this).data('display-value'));
		});

		$input.on('blur', function () {
			setTimeout(function () {
				if ($input.val() !== validValue) {
					$input.val(validValue);
					$select.val(validId);
				}
				$list.hide();
			}, 120);
		});

		$select.on('change.cityAutocomplete', function () {
			const value = $select.val() || '';
			const text = value ? ($select.find('option:selected').text() || validValue) : '';
			validId = value;
			validValue = text;
			$input.val(text);
		});
	}

	function initCityTags($input) {
		if ($input.data('cityAutocompleteReady')) return;
		$input.data('cityAutocompleteReady', true);

		const url = citySearchUrl($input);
		const hiddenName = $input.data('hidden-name') || $input.data('name') || 'cities';
		const $hidden = $('input[name="' + hiddenName + '"]').not($input).first();
		const $field = $input.closest('.resume-tag-input');
		const $list = $field.next('.resume-autocomplete-list');
		const initialSelected = ($hidden.val() || '').split(',').map(function (item) {
			return item.trim();
		}).filter(Boolean);
		const selected = [];
		let activeRequest = null;
		let debounceTimer = null;

		function syncHidden() {
			$hidden.val(selected.join(',')).trigger('change');
		}

		function addTag(name, displayName, focusInput) {
			if (!name || selected.some(function (item) { return item.toLowerCase() === name.toLowerCase(); })) {
				$input.val('');
				$list.hide();
				return;
			}

			displayName = displayName || name;
			const $tag = $('<div class="selected"></div>')
				.append($('<span></span>').text(displayName))
				.append($('<span class="remove">×</span>'));
			$tag.find('.remove').on('click', function () {
				const index = selected.indexOf(name);
				if (index !== -1) selected.splice(index, 1);
				$tag.remove();
				syncHidden();
			});
			$field.prepend($tag);
			selected.push(name);
			syncHidden();
			$input.val('');
			if (focusInput !== false) {
				$input.trigger('focus');
			}
			$list.hide();
		}

		function render(items) {
			const query = cityQuery($input.val()).toLowerCase();
			$list.empty();
			items.filter(function (city) {
				return !selected.some(function (name) { return name.toLowerCase() === city.name.toLowerCase(); });
			}).forEach(function (city) {
				const displayName = city.display_name || city.name;
				$list.append($('<li></li>').text(displayName).attr('data-value', city.name).attr('data-display-value', displayName));
			});
			$list.toggle($list.children().length > 0 && query !== '');
		}

		function load(query) {
			query = cityQuery(query);
			if (!query.length) {
				if (activeRequest) {
					activeRequest.abort();
					activeRequest = null;
				}
				$list.empty().hide();
				return;
			}
			if (activeRequest) activeRequest.abort();
			activeRequest = fetchCities(url, query, render).always(function () {
				activeRequest = null;
			});
		}

		initialSelected.forEach(function (name) {
			addTag(name, name, false);
		});

		$input.on('focus click', function (event) {
			event.stopPropagation();
			$list.hide();
		});

		$input.on('input', function () {
			clearTimeout(debounceTimer);
			debounceTimer = setTimeout(function () {
				load($input.val());
			}, 250);
		});

		$input.on('keydown', function (event) {
			if (event.key !== 'Enter') return;
			event.preventDefault();
			const $first = $list.find('li:first');
			if ($first.length) addTag($first.data('value'), $first.data('display-value'));
		});

		$list.on('mousedown', 'li', function (event) {
			event.preventDefault();
			addTag($(this).data('value'), $(this).data('display-value'));
		});
	}

	function initCityName($input) {
		if ($input.data('cityAutocompleteReady')) return;
		$input.data('cityAutocompleteReady', true);

		const url = citySearchUrl($input);
		const $dropdown = $input.closest('.city-dropdown');
		const $selected = $dropdown.find('.dropdown-selected');
		const $hidden = $dropdown.find('input[name="city"]');
		const $list = $input.closest('.dropdown-list');
		let activeRequest = null;
		let debounceTimer = null;
		let validValue = $hidden.val() || '';

		function render(items) {
			$list.find('li').remove();
			items.forEach(function (city) {
				const displayName = city.display_name || city.name;
				$list.append($('<li></li>').text(displayName).attr('data-value', displayName));
			});
			$list.toggle($list.find('li').length > 0 || $input.is(':focus'));
		}

		function load(query) {
			query = cityQuery(query);
			if (!query.length) {
				if (activeRequest) {
					activeRequest.abort();
					activeRequest = null;
				}
				$list.find('li').remove();
				if (!$input.is(':focus')) {
					$list.hide();
				}
				return;
			}
			if (activeRequest) activeRequest.abort();
			activeRequest = fetchCities(url, query, render).always(function () {
				activeRequest = null;
			});
		}

		function selectCity(name) {
			validValue = name;
			$hidden.val(name).trigger('change');
			$selected.text(name).attr('data-selected', name);
			$input.val('');
			$list.hide();
		}

		$selected.off('click.cityAutocomplete').on('click.cityAutocomplete', function (event) {
			event.preventDefault();
			event.stopPropagation();
			$('.dropdown-list').not($list).hide();
			$list.show();
			$input.val('').trigger('focus');
			load('');
		});

		$input.off('input.cityAutocomplete focus.cityAutocomplete click.cityAutocomplete')
			.on('focus.cityAutocomplete click.cityAutocomplete', function (event) {
				event.stopPropagation();
				load('');
			})
			.on('input.cityAutocomplete', function () {
				clearTimeout(debounceTimer);
				debounceTimer = setTimeout(function () {
					load($input.val());
				}, 250);
			});

		$list.off('mousedown.cityAutocomplete', 'li').on('mousedown.cityAutocomplete', 'li', function (event) {
			event.preventDefault();
			selectCity($(this).data('value'));
		});

		$input.on('blur.cityAutocomplete', function () {
			setTimeout(function () {
				$input.val('');
				$list.hide();
			}, 120);
		});
	}

	$(function () {
		$('[data-city-autocomplete="select"]').each(function () {
			initCitySelect($(this));
		});
		$('[data-city-autocomplete="tags"]').each(function () {
			initCityTags($(this));
		});
		$('[data-city-autocomplete="name"]').each(function () {
			initCityName($(this));
		});

		$(document).on('click', function (event) {
			if (!$(event.target).closest('.resume-city-autocomplete, .resume-tag-input, .resume-autocomplete-list').length) {
				$('.resume-autocomplete-list').hide();
			}
		});
	});
})(jQuery);
